import {
    Component,
    OnInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef, AfterViewInit
} from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap';
import {ShortcutsComponent} from '../modals/shortcuts/shortcuts.component';
import {BsModalEventsEmitter} from '../../events/bsModal.events';
import {TriggerActionEventsEmitter} from '../../events/triggerAction.events';
import {Router} from '@angular/router';

@Component({
    selector: 'app-mobilebar',
    templateUrl: './mobilebar.component.html',
    styleUrls: ['./mobilebar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MobilebarComponent implements OnInit, AfterViewInit {
    shortcutsModal: BsModalRef;

    constructor(
        private readonly changeDetectorRef: ChangeDetectorRef,
        private readonly bsModalService: BsModalService,
        public readonly bsModalRef: BsModalRef,
        private readonly bsModalEventsEmitter: BsModalEventsEmitter,
        private readonly triggerActionEventsEmitter: TriggerActionEventsEmitter,
        private readonly router: Router
    ) {
    }

    ngOnInit(): void {
        console.log('IS IOS');
        console.log(this.isIOS());
    }

    isIOS() {
        return [
                'iPad Simulator',
                'iPhone Simulator',
                'iPod Simulator',
                'iPad',
                'iPhone',
                'iPod'
            ].includes(navigator.platform)
            // iPad on iOS 13 detection
            || (navigator.userAgent.includes('Mac') && 'ontouchend' in document);
    }

    openShortcutsModal() {
        this.shortcutsModal = this.bsModalService.show(ShortcutsComponent, {
            backdrop: true
        });

        this.bsModalEventsEmitter.broadcastBsModalStateChanged(this.shortcutsModal);
    }

    ngAfterViewInit(): void {
    }

    openShoppingListModal() {
        this.router.navigate(['meals']);

        setTimeout(() => {
            this.triggerActionEventsEmitter.broadcastActionChanged({
                'action': 'shopping_list',
                'data': []
            });
        }, 200);
    }

    openRecipesTextModal() {
        this.router.navigate(['meals']);

        setTimeout(() => {
            this.triggerActionEventsEmitter.broadcastActionChanged({
                'action': 'recipes_text',
                'data': []
            });
        }, 200);
    }
}
